import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Copy protection is disabled

// Set up persistent visitor ID and override fetch to auto-inject header
let visitorId = localStorage.getItem("visitor_id");
if (!visitorId) {
  visitorId = "visit_" + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  localStorage.setItem("visitor_id", visitorId);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
